module.exports = __webpack_public_path__ + "static/img/csmj_icon.9ee76ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/download/csmj_icon.png
// module id = 75ge
// module chunks = 3